import { Skeleton } from "@garther/ui/components";
import { cn } from "@garther/ui/libs";
import { memo } from "react";

interface Props {
  className?: string;
}

const FeaturedEventsLoading = memo(({ className }: Props) => {
  return (
    <div className={cn("w-full space-y-8", className)}>
      {/* Loading Skeleton - matches FeaturedEventCard structure */}
      <div className="relative flex flex-col-reverse md:flex-row overflow-hidden md:rounded-2xl w-full max-h-[400px] md:max-h-[400px] lg:max-h-[450px] h-full">
        {/* Content skeleton */}
        <div className="flex flex-col justify-between space-y-3 md:space-y-4 p-0 pt-2 sm:p-3 md:p-5 lg:p-6 bg-background-secondary md:basis-1/3 lg:basis-2/5 md:rounded-2xl md:border-l-[2px] md:border-y-[2px] border-border">
          <div className="space-y-2 md:space-y-3">
            <div className="space-y-2 md:space-y-3">
              <Skeleton className="h-6 md:h-8 w-3/4" />
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-5/6" />
              <Skeleton className="h-4 w-4/5 hidden md:block" />
            </div>

            <div className="space-y-2 md:space-y-1">
              <div className="flex items-center gap-2">
                <Skeleton className="h-4 w-4 md:h-5 md:w-5 rounded-sm" />
                <Skeleton className="h-4 w-32 md:w-40" />
              </div>
              <div className="flex items-center gap-2">
                <Skeleton className="h-4 w-4 md:h-5 md:w-5 rounded-sm" />
                <Skeleton className="h-4 w-28 md:w-36" />
              </div>
              <div className="flex items-center gap-2">
                <Skeleton className="h-4 w-4 md:h-5 md:w-5 rounded-sm" />
                <Skeleton className="h-4 w-24 md:w-32" />
              </div>
            </div>

            <div className="pt-1 md:pt-2">
              <Skeleton className="h-6 md:h-8 w-24 md:w-32 rounded-full" />
            </div>
          </div>
        </div>

        {/* Image skeleton */}
        <div className="relative w-full flex-1 e-center overflow-hidden md:overflow-visible md:basis-2/3 lg:basis-3/5 aspect-[16/9] md:aspect-auto rounded-xl">
          <Skeleton className="h-full w-full" />
          <svg
            width="4"
            height="415"
            viewBox="0 0 4 415"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="hidden md:block absolute left-0 -translate-x-1/2"
          >
            <path
              stroke="#D1D5DB"
              strokeWidth="4"
              strokeLinecap="round"
              strokeDasharray="4 10"
              d="M2 2v411"
            ></path>
          </svg>
          <div className="hidden md:block absolute w-10 h-10 lg:w-12 lg:h-12 -top-5 lg:-top-6 -left-5 lg:-left-6 bg-background-secondary rounded-full border-b-[2px] border-l-[2px] border-r-0 border-border" />
          <div className="hidden md:block absolute w-10 h-10 lg:w-12 lg:h-12 -bottom-5 lg:-bottom-6 -left-5 lg:-left-6 bg-background-secondary rounded-full border-[2px] border-l-[2px] border-r-0 border-border" />
        </div>
      </div>
    </div>
  );
});

FeaturedEventsLoading.displayName = "FeaturedEventsLoading";
export default FeaturedEventsLoading;
